import NotificationList from "./NotificationList";
import { Drawer } from "@mui/material";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import styled from "@emotion/styled";
import { Notification } from "../../types";

interface Props {
  isOpen: boolean;
  notifications: Notification[];
  onClose: () => void;
}

export const NotificationsDrawer = ({
  isOpen,
  notifications,
  onClose,
}: Props) => {
  return (
    isOpen && (
      <Drawer
        sx={{
          width: "20vw",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "20vw",
          },
        }}
        variant="persistent"
        anchor="right"
        open={isOpen}
        onClose={onClose}
      >
        <DrawerHeader
          style={{
            justifyContent: "flex-start",
          }}
        >
          <IconButton onClick={onClose}>
            <ChevronRightIcon />
          </IconButton>
        </DrawerHeader>
        <Divider />
        <NotificationList notifications={notifications} />
      </Drawer>
    )
  );
};

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  justifyContent: "flex-end",
}));
